module.exports = __webpack_public_path__ + "img/09.b36f35d4.png";